interface ExportFileProps {
  file: string;
  projectId: string;
  token: string;
  category: number;
}

/**
 * 觸發匯出檔下載（後端 GET 回 Content-Disposition: attachment）。
 *
 * WHY 不用 window.open：三個呼叫點都是在 react-query mutation 的 onSuccess（非同步回呼）
 * 裡觸發，Chrome 的 transient user activation 約 5 秒就過期；大名單 POST 跑 30 秒以上時，
 * window.open 會被彈出視窗攔截器靜默擋掉，使用者看到「按了沒反應」（9uP_zxzv4G 二次客訴）。
 * 改用隱藏 <a download> 做同分頁導航下載：不需要使用者操作授權、瀏覽器收到 attachment
 * 就直接存檔，SPA 不會離開目前頁面。
 *
 * WHY 不用 location.assign：後端在 file token 過期時回 200 純文字「檔案已過期」、
 * 401/500 回 JSON，location.assign 會把整個 SPA 換成那頁；同網域的 <a download>
 * 則只會變成一筆失敗/純文字的下載，頁面與篩選狀態都保留。
 *
 * 注意環境差異：上述「錯誤時不離開頁面」只在 fileUrl 與前端同網域時成立（PROD 的
 * MALASUN_API_DOMAIN 是 platform.goskyai.com/api，同網域）。SIT/PREL/本機的 fileUrl 在
 * malasun-sit / malasun-prel 網域，瀏覽器會忽略 download 屬性，成功仍靠 attachment 下載，
 * 但錯誤回應（無 attachment）會整頁導航到 API 的純文字/JSON 頁，這是已知差異不是 bug。
 */
export const openExportFile = ({
  file,
  projectId,
  token,
  category,
}: ExportFileProps) => {
  // 用 URL API 組參數：自動處理 ?/& 連接與編碼，file 沒帶 query 時也不會組出壞 URL；
  // 既有 fileUrl 都是絕對網址（MALASUN_API_DOMAIN），第二參數只是相對路徑時的保險
  const url = new URL(file, window.location.origin);
  url.searchParams.set('projectId', projectId);
  url.searchParams.set('token', token);
  url.searchParams.set('category', String(category));
  const anchor = document.createElement('a');
  anchor.href = url.toString();
  // 空字串＝沿用後端 Content-Disposition 的檔名；跨網域時瀏覽器會忽略 download 改走一般導航，
  // 仍靠 attachment header 下載
  anchor.download = '';
  anchor.style.display = 'none';
  // 舊版 Firefox 需要 anchor 在 DOM 內 click 才會生效
  document.body.appendChild(anchor);
  try {
    anchor.click();
  } finally {
    anchor.remove();
  }
};
